import styled from 'styled-components';

import { BasicSubtitle } from '../../../../../../foundations/typefaces/BasicSubtitle';

export const TitleInput = styled(BasicSubtitle)(({ theme: { transition } }) => ({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  border: 0,
  transition: transition.standard(),
  cursor: 'text',
  padding: 0,
}));

export const StyledBasicSubtitle = styled(BasicSubtitle)({
  cursor: 'default',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
});
